import React from 'react';
import PropTypes from 'prop-types';
import s from './Sidebar.css';
import Navigation from '../Navigation';

class Sidebar extends React.Component {
  static propTypes = {
    locale: PropTypes.objectOf(PropTypes.string).isRequired,
  };

  render() {
    return (
      <aside className={s.aside}>
        <Navigation locale={this.props.locale} />
      </aside>
    );
  }
}

export default (Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js